// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; 
// import LoginPage from './components/login';
// import Register from './components/register';
// import Dashboard from './components/dashboard';
// import NewHireUpload from './components/newHireUpload';
// import Reports from './components/reports';
// import Footer from './components/footer';
// import UpdateEmployeeInfo from './components/update';  
// import Profile from './components/profile';
// import Employee from './components/employee';
// import EmployeeProfile from './components/employeeProfile';
// import ChangePassword from './components/changePassword';
// import ForgotPasswordPage from './components/forgotpassword';

// import SSSLoan from './components/loans/sssLoan';
// import PagIbigLandbankCard from './components/loans/pagIbigLandbankCard';
// import PagIbigVirtualAccount from './components/loans/pagIbigVirtualAccount';
// import MaternityNotification from './components/loans/MaternityNotification';
// import MaternityBenefit from './components/loans/MaternityBenefit';
// import SSSRequest from './components/request/SSSrequest';
// import PAGIBIGrequest from './components/request/PAG-IBIGrequest';
// import PHILHEALTHrequest from './components/request/PHILHEALTHrequest';

// import Submissions from './components/submission/submission';
// import SubmissionView from './components/submission/submissionView';

// import HRIAssist from './components/hriassist/hrIAssist';
// import MaternityTracker from './components/hriassist/MaternityTracker';
// import RequestView from './components/hriassist/requestView';
// import ViewNotifications from './components/notification/viewNotifications';
 
// import SicknessNotification from './components/sickness/SicknessNotification';
// import SicknessApproval from './components/sickness/SicknessApproval';

// import UpdateEmployee from './components/hriassist/UpdateEmployee';
// import OtherRequest from './components/hriassist/OtherRequest';


// import LoanTracker from './components/loanManagement/loanTracker';
// import SSSBilling from './components/loanManagement/uploadBilling/sssBilling';
// import PagibigBilling from './components/loanManagement/uploadBilling/pagibigBilling';
// import Certificate from './components/loanManagement/Certificate';
// import LoanPayments from './components/loanManagement/loanPayments';

// import Test from './components/test';
// import LoanStoppage from './components/loans/loanStoppage';


// function App() {
  
//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           <Route path="/" element={<LoginPage />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/register" element={<Register />} />
//           <Route path="/newHireUpload" element={<NewHireUpload />} />
//           <Route path="/footer" element={<Footer />} />
//           <Route path="/reports" element={<Reports />} />
//           <Route path="/profile" element={<Profile />} />
//           <Route path="/update" element={<UpdateEmployeeInfo />} />
//           <Route path="/update/:employeeId" element={<UpdateEmployeeInfo />} />
//           <Route path="/employee" element={<Employee />} />
//           <Route path="/employeeProfile" element={<EmployeeProfile />} />
//           <Route path="/changePassword" element={<ChangePassword />} />
//           <Route path="/forgotpassword" element={<ForgotPasswordPage/>}></Route>

//           {/* Submission Pages */}
//           <Route path="/submissions" element={<Submissions />} />
//             <Route path="/submissionview" element={<SubmissionView/>} />

//           {/* iAssist Pages */} 
//             <Route path="/sssloan" element={<SSSLoan />} />
//             <Route path="/landbankcard" element={<PagIbigLandbankCard />} />
//             <Route path="/virtualaccount" element={<PagIbigVirtualAccount />} />
//             <Route path="/notification" element={<MaternityNotification />} />
//             <Route path="/benefit" element={<MaternityBenefit />} />

//             <Route path="/SSSrequest" element={<SSSRequest />} />
//             <Route path="/PIrequest" element={<PAGIBIGrequest />} />
//             <Route path="/PHILHEALTHrequest" element={<PHILHEALTHrequest />} />

//             <Route path="/SicknessNotification" element={<SicknessNotification />} /> 
//             <Route path="/LoanStoppage" element={<LoanStoppage />} />
//             <Route path="/SicknessApproval" element={<SicknessApproval />} /> 
//             <Route path="/UpdateEmployee" element={<UpdateEmployee />} />
//             <Route path="/OtherRequest" element={<OtherRequest />} />

//           {/* HR iAssist Pages */}
//           <Route path="/hriassist" element={<HRIAssist />} />
//           <Route path="/MaternityTracker" element={<MaternityTracker />} />
//             <Route path="/request" element={<RequestView />} />

//           {/* Loan Tracker */}
//           <Route path="/loantracker" element={<LoanTracker />} /> 
//           <Route path="/uploadbilling/sss" element={<SSSBilling />} />
//           <Route path="/uploadbilling/pagibig" element={<PagibigBilling />} />
//           <Route path="/certificate/certificateloan" element={<Certificate />} />
//           <Route path="/loanpayments/payments" element={<LoanPayments/>}/>
   
//           {/* All */}
//           <Route path="/viewnotifications" element={<ViewNotifications />} />

//             <Route path="/test" element={<Test/>} />

//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; 
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

import LoginPage from './components/login';
import Register from './components/register';
import Dashboard from './components/dashboard';
import NewHireUpload from './components/newHireUpload';
import Reports from './components/reports';
import Footer from './components/footer';
import UpdateEmployeeInfo from './components/update';  
import Profile from './components/profile';
import Employee from './components/employee';
import EmployeeProfile from './components/employeeProfile';
import ChangePassword from './components/changePassword';
import ForgotPasswordPage from './components/forgotpassword';

import SSSLoan from './components/loans/sssLoan';
import PagIbigLandbankCard from './components/loans/pagIbigLandbankCard';
import PagIbigVirtualAccount from './components/loans/pagIbigVirtualAccount';
import MaternityNotification from './components/loans/MaternityNotification';
import MaternityBenefit from './components/loans/MaternityBenefit';
import SSSRequest from './components/request/SSSrequest';
import PAGIBIGrequest from './components/request/PAG-IBIGrequest';
import PHILHEALTHrequest from './components/request/PHILHEALTHrequest';

import Submissions from './components/submission/submission';
import SubmissionView from './components/submission/submissionView';

import HRIAssist from './components/hriassist/hrIAssist';
import MaternityTracker from './components/hriassist/MaternityTracker';
import RequestView from './components/hriassist/requestView';
import ViewNotifications from './components/notification/viewNotifications';
 
import SicknessNotification from './components/sickness/SicknessNotification';
import SicknessApproval from './components/sickness/SicknessApproval';

import UpdateEmployee from './components/hriassist/UpdateEmployee';
import OtherRequest from './components/hriassist/OtherRequest';

import LoanTracker from './components/loanManagement/loanTracker';
import SSSBilling from './components/loanManagement/uploadBilling/sssBilling';
import PagibigBilling from './components/loanManagement/uploadBilling/pagibigBilling';
import Certificate from './components/loanManagement/Certificate';
import LoanPayments from './components/loanManagement/loanPayments';

import Test from './components/test';
import LoanStoppage from './components/loans/loanStoppage';
// import EmployeeTaxForm1902 from './components/taxForm/EmployeeTaxForm';
// import TaxFormSubmissions from './components/taxForm/TaxFormSubmissions';
// import TaxFormArchive from './components/taxForm/TaxFormArchive';
// import TaxFormThankYou from './components/taxForm/TaxFormThankYou';

const BOTH = ['HRAdmin', 'Employee'];
const HR_ONLY = ['HRAdmin'];

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>

          {/* ── Public (redirect away if already logged in) ── */}
          <Route path="/" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/forgotpassword" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
          <Route path="/register" element={<ProtectedRoute allowedRoles={HR_ONLY}><Register /></ProtectedRoute>} />

          {/* ── HR Admin only ── */}
          <Route path="/dashboard" element={<ProtectedRoute allowedRoles={HR_ONLY}><Dashboard /></ProtectedRoute>} />
          <Route path="/newHireUpload" element={<ProtectedRoute allowedRoles={HR_ONLY}><NewHireUpload /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute allowedRoles={HR_ONLY}><Reports /></ProtectedRoute>} />
          <Route path="/update" element={<ProtectedRoute allowedRoles={HR_ONLY}><UpdateEmployeeInfo /></ProtectedRoute>} />
          <Route path="/update/:employeeId" element={<ProtectedRoute allowedRoles={HR_ONLY}><UpdateEmployeeInfo /></ProtectedRoute>} />
          <Route path="/employee" element={<ProtectedRoute allowedRoles={HR_ONLY}><Employee /></ProtectedRoute>} />
          <Route path="/employeeProfile" element={<ProtectedRoute allowedRoles={HR_ONLY}><EmployeeProfile /></ProtectedRoute>} />
          <Route path="/hriassist" element={<ProtectedRoute allowedRoles={HR_ONLY}><HRIAssist /></ProtectedRoute>} />
          <Route path="/maternitytracker" element={<ProtectedRoute allowedRoles={HR_ONLY}><MaternityTracker /></ProtectedRoute>} />
          <Route path="/request" element={<ProtectedRoute allowedRoles={HR_ONLY}><RequestView /></ProtectedRoute>} />
          <Route path="/loantracker" element={<ProtectedRoute allowedRoles={HR_ONLY}><LoanTracker /></ProtectedRoute>} />
          <Route path="/uploadbilling/sss" element={<ProtectedRoute allowedRoles={HR_ONLY}><SSSBilling /></ProtectedRoute>} />
          <Route path="/uploadbilling/pagibig" element={<ProtectedRoute allowedRoles={HR_ONLY}><PagibigBilling /></ProtectedRoute>} />
          <Route path="/certificate/certificateloan" element={<ProtectedRoute allowedRoles={HR_ONLY}><Certificate /></ProtectedRoute>} />
          <Route path="/loanpayments/payments" element={<ProtectedRoute allowedRoles={HR_ONLY}><LoanPayments /></ProtectedRoute>} />
          <Route path="/SicknessApproval" element={<ProtectedRoute allowedRoles={HR_ONLY}><SicknessApproval /></ProtectedRoute>} />

          {/* ── Both HR Admin and Employee ── */}
          <Route path="/submissions" element={<ProtectedRoute allowedRoles={BOTH}><Submissions /></ProtectedRoute>} />
          <Route path="/submissionview" element={<ProtectedRoute allowedRoles={BOTH}><SubmissionView /></ProtectedRoute>} />
          <Route path="/sssloan" element={<ProtectedRoute allowedRoles={BOTH}><SSSLoan /></ProtectedRoute>} />
          <Route path="/landbankcard" element={<ProtectedRoute allowedRoles={BOTH}><PagIbigLandbankCard /></ProtectedRoute>} />
          <Route path="/virtualaccount" element={<ProtectedRoute allowedRoles={BOTH}><PagIbigVirtualAccount /></ProtectedRoute>} />
          <Route path="/loanStoppage" element={<ProtectedRoute allowedRoles={BOTH}><LoanStoppage /></ProtectedRoute>} />
          <Route path="/notification" element={<ProtectedRoute allowedRoles={BOTH}><MaternityNotification /></ProtectedRoute>} />
          <Route path="/benefit" element={<ProtectedRoute allowedRoles={BOTH}><MaternityBenefit /></ProtectedRoute>} />
          <Route path="/SSSrequest" element={<ProtectedRoute allowedRoles={BOTH}><SSSRequest /></ProtectedRoute>} />
          <Route path="/PIrequest" element={<ProtectedRoute allowedRoles={BOTH}><PAGIBIGrequest /></ProtectedRoute>} />
          <Route path="/PHILHEALTHrequest" element={<ProtectedRoute allowedRoles={BOTH}><PHILHEALTHrequest /></ProtectedRoute>} />
          <Route path="/SicknessNotification" element={<ProtectedRoute allowedRoles={BOTH}><SicknessNotification /></ProtectedRoute>} />
          <Route path="/UpdateEmployee" element={<ProtectedRoute allowedRoles={BOTH}><UpdateEmployee /></ProtectedRoute>} />
          <Route path="/OtherRequest" element={<ProtectedRoute allowedRoles={BOTH}><OtherRequest /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute allowedRoles={BOTH}><Profile /></ProtectedRoute>} />
          <Route path="/changePassword" element={<ProtectedRoute allowedRoles={BOTH}><ChangePassword /></ProtectedRoute>} />
          <Route path="/viewnotifications" element={<ProtectedRoute allowedRoles={BOTH}><ViewNotifications /></ProtectedRoute>} />

          {/* ── Tax Form Routes */}
          {/* <Route path="/taxform1902" element={<ProtectedRoute allowedRoles={BOTH}><EmployeeTaxForm1902 /></ProtectedRoute>} />
          <Route path="/taxforms/submissions" element={<ProtectedRoute allowedRoles={HR_ONLY}><TaxFormSubmissions /></ProtectedRoute>} />
          <Route path="/taxforms/archive" element={<ProtectedRoute allowedRoles={HR_ONLY}><TaxFormArchive /></ProtectedRoute>} />
          <Route path="/taxform-thankyou" element={<ProtectedRoute allowedRoles={BOTH}><TaxFormThankYou /></ProtectedRoute>} /> */}

          {/* ── Dev only, remove in production ── */}
          <Route path="/test" element={<Test />} />
          <Route path="/footer" element={<Footer />} />

        </Routes>
      </div>
      {/* <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}
    </Router>
  );
}

export default App;